<template>
  <!-- 基本信息 -->
  <div class="w-full h-full flex flex-col">
    <!-- <el-divider content-position="left">
      <span class="text-16px font-600">基本信息</span>
    </el-divider>
    <el-form
      ref="baseForm"
      size="mini"
      label-width="130px"
      v-loading="formLoading"
      :model="baseForm"
    >
      <el-row>
        <el-col span="6">
          <el-form-item label="企业名称" prop="orgName">
            <el-input
              class="w-full"
              v-model="baseForm.orgName"
              placeholder="请输入企业名称"
              size="small"
              clearable
              disabled
            />
          </el-form-item>
        </el-col>
        <el-col span="6" offset="2">
          <el-form-item label="企业简称" prop="orgName">
            <el-input
              class="w-full"
              v-model="baseForm.orgName"
              placeholder="请输入企业简称"
              size="small"
              clearable
              disabled
            />
          </el-form-item>
        </el-col>
        <el-col span="6" offset="2">
          <el-form-item label="项目名称" prop="orgName">
            <el-input
              class="w-full"
              v-model="baseForm.orgName"
              placeholder="请输入项目名称"
              size="small"
              clearable
              disabled
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col span="6">
          <el-form-item label="合同编号" prop="orgName">
            <el-input
              class="w-full"
              v-model="baseForm.orgName"
              placeholder="请输入合同编号"
              size="small"
              clearable
              disabled
            />
          </el-form-item>
        </el-col>
        <el-col span="6" offset="2">
          <el-form-item label="单位负责人" prop="orgName">
            <el-input
              class="w-full"
              v-model="baseForm.orgName"
              placeholder="请输入单位负责人"
              size="small"
              clearable
              disabled
            />
          </el-form-item>
        </el-col>
        <el-col span="6" offset="2">
          <el-form-item label="联系人电话" prop="orgName">
            <el-input
              class="w-full"
              v-model="baseForm.orgName"
              placeholder="请输入联系人电话"
              size="small"
              clearable
              disabled
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="flex-1 overflow-y-auto">
      <AptitudeForm :aptitudeList="aptitudeList" />
    </div> -->
    <person-enter-content
      v-if="isShow"
      :FormData="FormData"
      :formList="formList"
      @back="handleBack"
      @save="handleBack"
      :pageType="pageType"
    ></person-enter-content>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import {
  ContractorPersonnelApi,
  ContractorApi,
  GuidanceConfigurationApi,
  ContractorPersonnelConfigurationApi,
  ContractorPersonnelCertificateApi,
} from '@wiz-api/contractor-management'
import PersonEnterContent from '@/components/safety/WizSafetyPage/PersonEnterContent'
// import AptitudeForm from './AptitudeForm/AptitudeForm.vue'
const guidanceConfigurationApi = new GuidanceConfigurationApi()
const contractorPersonnelApi = new ContractorPersonnelApi()
const contractorPersonnelCertificateApi = new ContractorPersonnelCertificateApi()
const contractorPersonnelConfigurationApi = new ContractorPersonnelConfigurationApi()

export default {
  name: 'base-info',
  props: {},
  components: {
    // AptitudeForm
    PersonEnterContent,
  },
  data() {
    return {
      pageType: 'detail',
      formLoading: false,
      baseForm: {},
      aptitudeList: [
        {
          id: '3a0c841f-848a-1a77-0d3a-5b485b18bf34',
          templateName: null,
          title: '营业执照',
          directoryName: '资质审查资料',
          directoryId: '3a0c8330-73e6-e882-0dbc-4f9edefce2d6',
          templateId: '3a0c841f-83de-d59a-77b6-f06dc6f3f1ac',
          configurationId: '3a0c8332-44d6-6c96-82f0-35b8c14b55d0',
        },
        {
          id: '3a0c841f-848a-5f66-97e9-c8a1acbcfd98',
          templateName: null,
          title: '安全生产许可证',
          directoryName: '资质审查资料',
          directoryId: '3a0c8330-73e6-e882-0dbc-4f9edefce2d6',
          templateId: '3a0c841f-83de-d59a-77b6-f06dc6f3f1ac',
          configurationId: '3a0c833f-c47f-55ca-dcce-64391ce7b501',
        },
        {
          id: '3a0c841f-848a-7ee0-7d2f-008908a6665b',
          templateName: null,
          title: '法人资格证书(法人授权委托书)',
          directoryName: '资质审查资料',
          directoryId: '3a0c8330-73e6-e882-0dbc-4f9edefce2d6',
          templateId: '3a0c841f-83de-d59a-77b6-f06dc6f3f1ac',
          configurationId: '3a0c8333-dd1c-24f8-c6bb-f09c794094c3',
        },
        {
          id: '3a0c841f-848a-8c8b-393e-d9db735ccbfb',
          templateName: null,
          title: '被授权人的省份证(留复印件)',
          directoryName: '资质审查资料',
          directoryId: '3a0c8330-73e6-e882-0dbc-4f9edefce2d6',
          templateId: '3a0c841f-83de-d59a-77b6-f06dc6f3f1ac',
          configurationId: '3a0c833e-6441-db86-fcb9-b8618196d01f',
        },
        {
          id: '3a0c841f-848a-b4df-be5f-4ca3816490da',
          templateName: null,
          title: '管理层的安全承诺、政策及目标',
          directoryName: '资质审查资料',
          directoryId: '3a0c8330-73e6-e882-0dbc-4f9edefce2d6',
          templateId: '3a0c841f-83de-d59a-77b6-f06dc6f3f1ac',
          configurationId: '3a0c8335-da66-233b-164d-f080b28c4c05',
        },
        {
          id: '3a0c841f-848a-353f-c28d-8c3648c4b726',
          templateName: null,
          title: '资质名称',
          directoryName: '测试222',
          directoryId: '3a0c801f-4fac-05b4-61ac-ffb67c089437',
          templateId: '3a0c841f-83de-d59a-77b6-f06dc6f3f1ac',
          configurationId: '3a0c8029-a5f7-9fcc-390c-78da3f4d41ec',
        },
      ],

      FormData: {
        infDocFileName: '',
        infDocFileId: '',
        name: '',
        phoneNumber: '',
        age: null,
        idCard: '',
        sex: null,
        national: '',
        education: null,
        isTemp: true,
        personnelCategory: null,
        team: null,
        dutieJob: null,
        isSpecialOperationCertificatePersonnel: true,
        contractorId: '',
        projectId: '',
        headshotFileId: '',
        idCardFrontFileId: '',
        idCardReverseFileId: '',
        jobs: null,
        contractorPersonnelConfigurations: [],
        contractorPersonnelCertificates: [],
      },
      formList: [],
      isShow: false,
    }
  },
  created() {},
  methods: {
    handleBack() {
      this.$emit('back')
    },
    async handleDetail(row) {
      this.FormData = this.$options.data().FormData
      const [error, result] = await contractorPersonnelApi.get(row.id)
      if (!error) {
        this.FormData = {
          ...this.FormData,
          ...result,
        }
        // 获取证书是否提供
        const [
          errCard,
          resCard,
        ] = await contractorPersonnelCertificateApi.contractorPersonnelCertificateDto({
          contractorPersonnelId: row.id,
        })
        if (!errCard) {
          // 时间格式化
          resCard.forEach((item, index) => {
            item.certificateDate = dayjs(item.certificateDate).format('YYYY-MM-DD')
          })
          this.$set(this.FormData, 'contractorPersonnelCertificates', resCard)
        }
        // 获取资料是否提供
        const [
          err,
          res,
        ] = await contractorPersonnelConfigurationApi.contractorPersonnelConfiguration({
          contractorPersonnelId: row.id,
        })
        if (!err) {
          this.formList = res.map((item, index) => {
            return {
              id: item.id,
              configurationId: item.configurationId,
              label: item.title,
              field: `field${index}`,
              textfield: `textfield${index}`,
              // 获取有无情况以及说明
              isProvided: item.isProvided,
              description: item.description,
            }
          })
        }
      }
      this.isShow = false
      this.$nextTick(() => {
        this.isShow = true
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
